export enum MetabolizerStatuses {
    POOR = 'poor',
    NORMAL = 'normal',
    INTERMEDIATE = 'intermediate',
    RAPID = 'rapid',
}
